import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Form, Input, Button, Divider, Radio, notification, Popconfirm, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FeatherIcon } from 'feather-icons-react';
import { RecordViewWrapper, SucursalCard } from './Style';
import { Main, TableWrapper } from '../../styled';
import {
  sucursalUnidadesMedicasListAction,
  sucursalUnidadMedicaCreateAction,
  sucursalUnidadMedicaDeleteAction,
} from '../../../redux/administracion/sucursales/actionCreator';
import { PageHeader } from '../../../components/page-headers/page-headers';

const SucursalUnidadesMedicasViewPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id, nombre } = useParams();
  const [form] = Form.useForm();
  const isLoading = useSelector(state => state.responseReducer.loading);
  // const registros = useSelector(state => state.SucursalReducer.dataUnidadesMedicas);
  const [registros, setRegistros] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [pageTitle, setPageTitle] = useState('Cargando listado...');

  useEffect(async () => {
    console.log('id:', id);
    form.setFieldsValue({ idSucursal: id });
    setPageTitle('Unidades médicas de: ' + nombre);
    await getRecords();
  }, [id]);

  const getRecords = async () => {
    let unidadesMedicasList = await dispatch(sucursalUnidadesMedicasListAction(id));
    setRegistros(unidadesMedicasList);
  };

  const hideModal = async () => {
    setModalVisible(false);
    await getRecords();
  };

  const handleSubmit = async values => {
    const responseApi = await dispatch(sucursalUnidadMedicaCreateAction(values));
    if (responseApi) {
      let mensaje = 'Unidad médica creada exitosamente';
      if (values.action === 'update') mensaje = 'Unidad médica actualizada exitosamente';
      notification.success({
        message: mensaje,
      });
      // dispatch(sucursalUnidadesMedicasListAction(id));
    } else {
      notification.error({
        message: 'Error al procesar unidad médica',
      });
    }
  };

  const eliminar = async id => {
    let values = { id };
    const responseApi = await dispatch(sucursalUnidadMedicaDeleteAction(values));
    if (responseApi) {
      let mensaje = 'Unidad médica eliminada exitosamente';
      notification.success({
        message: mensaje,
      });
      hideModal();
    } else {
      notification.error({
        message: 'Error al procesar unidad médica',
      });
    }
  };

  const noEliminar = e => {
    console.log(e);
  };

  const addRecord = () => {
    return (
      <Card style={{ marginTop: '10px' }}>
        <Form layout="vertical" size="small" name="form_in_modal" onFinish={handleSubmit} form={form}>
          <Form.Item
            name="nombre"
            label="Nombre de la unidad"
            rules={[{ required: true, message: 'Campo obligatorio' }]}
          >
            <Input placeholder="Ej. Cubiculo A o Sala 1, etc." />
          </Form.Item>
          <Form.Item name="activa" label="¿Unidad activa?" rules={[{ message: 'Campo obligatorio', required: true }]}>
            <Radio.Group>
              <Radio value="1">Si</Radio>
              <Radio value="2">No</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item name="id" initialValue="0">
            <Input hidden />
          </Form.Item>
          <Form.Item name="idSucursal">
            <Input hidden />
          </Form.Item>
          <Form.Item name="action" initialValue="create">
            <Input hidden />
          </Form.Item>
          <Button size="small" htmlType="Save" type="primary">
            {isLoading ? 'Cargando...' : 'Guardar'}
          </Button>
        </Form>
      </Card>
    );
  };

  const renderRecords = () => {
    return registros.map(registro => {
      return (
        <Card style={{ marginTop: '10px' }}>
          <Form layout="inline" size="small" name="form_in_modal" initialValues={registro} onFinish={handleSubmit}>
            <Form.Item name="nombre" label="Nombre" rules={[{ required: true, message: 'Campo obligatorio' }]}>
              <Input />
            </Form.Item>
            <Form.Item name="activa" label="¿Unidad activa?" rules={[{ message: 'Campo obligatorio', required: true }]}>
              <Radio.Group>
                <Radio value="1">Si</Radio>
                <Radio value="2">No</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="id">
              <Input hidden />
            </Form.Item>
            <Form.Item name="idSucursal">
              <Input hidden />
            </Form.Item>
            <Form.Item name="action" initialValue="update">
              <Input hidden />
            </Form.Item>
            <Button size="small" htmlType="Save" type="primary">
              Guardar
            </Button>{' '}
            &nbsp;
            <Popconfirm
              title="¿Eliminar éste registro?"
              onConfirm={() => eliminar(registro.id)}
              onCancel={noEliminar}
              okText="Si"
              cancelText="No"
            >
              <Button size="small" htmlType="Save" type="danger">
                Eliminar
              </Button>
            </Popconfirm>
          </Form>
        </Card>
      );
    });
  };

  return (
    <RecordViewWrapper>
      <PageHeader
        buttons={[
          <Button className="btn-add_new" size="default" key="1" type="primary" onClick={() => setModalVisible(true)}>
            Agrear unidad médica
          </Button>,
          <Button className="btn-add_new" size="default" key="2" type="primary">
            <Link to="/admin/sucursales/listado"> Volver al listado</Link>
          </Button>,
        ]}
        ghost
        title={pageTitle}
      />
      <Main>
        <Row gutter={15}>
          <Col className="w-100" md={24}>
            {registros.length <= 0 ? (
              <>
                <p className="text-center">
                  <br />
                  No hay unidades medicas registradas
                </p>
              </>
            ) : (
              <>{renderRecords()}</>
            )}
          </Col>
        </Row>
      </Main>
      <Modal title="Agregar unidad médica" visible={modalVisible} onCancel={hideModal} footer={[]}>
        {addRecord()}
      </Modal>
    </RecordViewWrapper>
  );
};

export default SucursalUnidadesMedicasViewPage;
